import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { RetryOnError, verifyToken } from "../utils/VerifyToken";
import { checkForAuthorization } from "utils/index";

const URL = () => `${process.env.REACT_APP_BASE_URL}/admin/dashboard-layout`;
const authHeader = () => ({ Authorization: `Bearer ${checkForAuthorization()}` });

// GET /admin/dashboard-layout -> the admin's saved layout object (unwrapped).
export const FetchDashboardLayout = () =>
    useQuery(["dashboard-layout"], () =>
        axios({ method: "get", url: URL(), headers: authHeader() }).then((res) => res?.data?.data?.layout ?? null),
    {
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => RetryOnError(failureCount, error),
        onError: (err) => verifyToken(err),
    });

// PUT /admin/dashboard-layout with the whole layout object; the response carries the stored layout.
export const SaveDashboardLayout = () =>
    useMutation(
        (layout) => axios({ method: "put", url: URL(), headers: { ...authHeader(), "Content-Type": "application/json" }, data: { layout } }),
        { retry: 0, onError: (err) => verifyToken(err) },
    );
